const initialState = {
  loading: false,
  totalSupply: "...",
  reservedAmount: "...",
  cost: "...",
  costInWei: 0,
  maxTokens: "...",
  mintActive: false,
  error: false,
  errorMsg: "",
};

const dataReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SMART_CONTRACT_DATA_REQUEST_PENDING":
      return {
        ...state,
        loading: true,
        error: false,
        errorMsg: "",
      };
    case "SMART_CONTRACT_DATA_REQUEST_SUCCESS":
      return {
        ...state,
        loading: false,
        totalSupply: action.payload.totalSupply,
        reservedAmount: action.payload.reservedAmount,
        cost: action.payload.cost / (10**18),
        costInWei: action.payload.cost,
        maxTokens: action.payload.maxTokens,
        mintActive: action.payload.mintActive,
        error: false,
        errorMsg: "",
      };
    case "SMART_CONTRACT_DATA_REQUEST_FAIL":
      return {
        ...initialState,
        loading: false,
        error: true,
        errorMsg: action.payload,
      };
    default:
      return state;
  }
};

export default dataReducer;
